import React from 'react'
import { Modal, App } from 'antd'
import { useUser_stateMutation } from '../../store/ReactWebSiteApi';

function UserDel(props) {
    const { message } = App.useApp();    
    const {confirm} = Modal; 
    const [submitDel] = useUser_stateMutation()   
    return (
        <>
           {props.eu_state==='1' &&  <a onClick={() => {
                                    confirm({
                                        title: `确定要删除${props.eu_name}吗？`,
                                        okText: '确认',
                                        okType: 'danger',
                                        cancelText: '取消',
                                        onOk() {
                                            submitDel({
                                                eu_id:props.eu_id,
                                                eu_state:'1'
                                            }).then((res) => {
                                                if (res.data.Status === 'success') {
                                                    message.info('删除成功！');
                                                }
                                                if (res.data.Status === "fail") {
                                                    message.error('删除失败！'+res.data.Message)
                                                }
                                            })
                                        },
                                        onCancel() {
                                        console.log('Cancel');
                                        },
                                    })
                                }}>删除</a>}
           {props.eu_state==='2' &&  <a onClick={() => {
                                    confirm({
                                        title: `确定要取消删除${props.eu_name}吗？`,
                                        okText: '确认',
                                        okType: 'danger',
                                        cancelText: '取消',
                                        onOk() {
                                            submitDel({
                                                eu_id:props.eu_id,
                                                eu_state:'2'
                                            }).then((res) => {
                                                if (res.data.Status === 'success') {
                                                    message.info('删除成功！');
                                                }
                                                if (res.data.Status === "fail") {
                                                    message.error('删除失败！'+res.data.Message)
                                                }
                                            })
                                        },
                                        onCancel() {
                                        console.log('Cancel');
                                        },
                                    })
                                }}>取消删除</a>}
        </>
    )
}

export default UserDel